import { AvailableLanguages } from '@repo/toolkit/language-types'

import { t } from '../../../../locale/utils'
import { StatusOption } from '../../utils'
import { NoneEnum } from './none.enum'

export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export const genderEnumValues = { ...GenderEnum, ...NoneEnum }
export type GenderEnumValues = keyof typeof genderEnumValues

export const genderEnumMapping = (
  language?: AvailableLanguages
): Record<GenderEnumValues, string> => ({
  NONE: 'Société',
  FEMALE: t('gender.enum.female', { language }),
  MALE: t('gender.enum.male', { language })
})

type GenderOptionMapping = {
  title: string
  gender: string
}

export const genderOptionsMapping: Record<GenderEnumValues, GenderOptionMapping> = {
  NONE: {
    title: 'Société',
    gender: 'Société'
  },
  FEMALE: {
    title: 'Mme',
    gender: 'Fille'
  },
  MALE: {
    title: 'M.',
    gender: 'Garçon'
  }
}

export const genderOneLetterMapping: Record<GenderEnumValues, StatusOption> = {
  NONE: {
    label: 'Société',
    variant: 'grey'
  },
  FEMALE: {
    label: 'F',
    variant: 'fushia'
  },
  MALE: {
    label: 'M',
    variant: 'blue'
  }
}

export const toGenderEnumValue = <K extends GenderEnum | null>(
  value: K // gender is either GenderEnum or null
): GenderEnumValues => {
  if (!value) return NoneEnum.NONE
  return value
}

export const toGenderEnum = (value: GenderEnumValues): GenderEnum | null => {
  if (value === NoneEnum.NONE) return null
  return value as GenderEnum
}
